// Module partagé pour le tri — évite le widget SortBy (Algolia) incompatible avec OpenSearch
const SORT_OPTIONS = [
  { key: "default",  label: "Pertinence",              sort: { field: "_score",       order: "desc" }, icon: "sort_amount_desc" },
  { key: "date_desc", label: "Date (plus récent)",       sort: { field: "date_sort",  order: "desc" }, icon: "sort_amount_desc" },
  { key: "date_asc",  label: "Date (plus ancien)",       sort: { field: "date_sort",  order: "asc" },  icon: "sort_amount_asc" },
  { key: "titre_asc", label: "Titre (alphabétique)",     sort: { field: "titre.keyword", order: "asc" },  icon: "sort_alpha_asc" },
];

let _currentSortKey = "default";

export function getSortOptions() {
  return SORT_OPTIONS;
}

export function getCurrentSortKey() {
  return _currentSortKey;
}

export function setCurrentSortKey(key) {
  _currentSortKey = key || "default";
}

export function getCurrentSort() {
  const opt = SORT_OPTIONS.find((o) => o.key === _currentSortKey);
  if (!opt || opt.key === "default") return null; // null = pertinence (_score)
  // Transformer {field,order} en format OpenSearch : [{ corrigeDate: "desc" }]
  return [{ [opt.sort.field]: opt.sort.order }];
}
